import React from 'react';
import { Switch, Button } from '@mui/material';
import Geocode from "react-geocode";
import { styled } from '@mui/material/styles';
import { Cloudinary } from "@cloudinary/url-gen";

import { config } from './config';

/****************ESTILOS*****************/

export const NewSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#404875',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export const ColorButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  backgroundColor: "#7395f8",
  "&:hover": {
    backgroundColor: "#6185f2",
  },
}));

/****************FUNCIONES*****************/

Geocode.setApiKey(config.mapAPI);
Geocode.setLanguage("es");

export const obtenerUbicacion = () => {
  if (navigator.geolocation) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(objPosition => {
        let lon = objPosition.coords.longitude;
        let lat = objPosition.coords.latitude;
        let accuracy = objPosition.coords.accuracy;

        resolve({ lon, lat, accuracy });
      }, objPositionError => {
        switch (objPositionError.code) {
          case objPositionError.PERMISSION_DENIED:
            console.log("No se ha permitido el acceso a la posición del usuario.")
            break;
          case objPositionError.POSITION_UNAVAILABLE:
            console.log("No se ha podido acceder a la información de su posición.");
            break;
          case objPositionError.TIMEOUT:
            console.log("El servicio ha tardado demasiado tiempo en responder.");
            break;
          default:
            console.log("Error desconocido.");
        }
      }, {
        maximumAge: 75000,
        timeout: 15000
      });
    })
  } else {
    console.log("Su navegador no soporta la API de geolocalización.");
  }
}

export const getLatLong = nombreDireccion => {
  return new Promise((resolve, reject) => {
    Geocode.fromAddress(nombreDireccion).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        resolve({ lat, lng });
      },
      error => {
        console.error(error);
      }
    );
  })
}

export const calcCrow = (lat1, lon1, lat2, lon2) => {
  let R = 6371; // km
  let dLat = toRad(lat2 - lat1);
  let dLon = toRad(lon2 - lon1);
  let lat1R = toRad(lat1);
  let lat2R = toRad(lat2);

  let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1R) * Math.cos(lat2R);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d;
}

// Converts numeric degrees to radians
const toRad = (Value) => {
  return Value * Math.PI / 180;
}

export const cld = new Cloudinary({
  cloud: {
    cloudName: 'daprno5qo',
    invalidate: false,
  }
});

export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export const areAllValuesEmpty = obj => {
  if (!obj || typeof obj !== 'object') return false;
  const values = Object.values(obj);
  if (values.length === 0) return true;

  return values.every(value => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string' && value.trim() === '') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && areAllValuesEmpty(value)) return true; // Verificación recursiva
    return false;
  });
}

/****************IMAGENES*****************/

export const urlImg = "https://res.cloudinary.com/daprno5qo/image/upload";